import { PocList, PocListItem } from 'commons/components/components-wrapper';
import styled from 'styled-components';
import { placeholderTextStyle } from 'commons/styles/placeholder-text.style';
import { SELECTED_OPTION_PLACEHOLDER_CLASS } from './select.constants';

export const SelectOptionPlaceholderTextStyled = styled.span`
    ${placeholderTextStyle}
`;

export const SelectLayout = styled.div`
    align-items: center;
    padding: 4px 0;

    &.inline {
        display: flex;
        justify-content: space-between;
    }

    &.without-label {
        flex: 1 1 auto;
    }

    owc-typography.label {
        color: var(--one-color-gray-600);

        &.block {
            padding-bottom: 8px;
        }
    }

    /* OWC-OVERRIDE: italicise the trigger text when the selected option is a placeholder.
       owc-select-dropdown renders the selected label as a plain string into owc-input's
       native input and exposes no font-style prop in v7.6.0, so the only way to style it
       is to reach the input directly. That works because owc-input is declared
       encapsulation: "scoped" (light DOM) — revisit if a future @one release shadows it. */
    &.${SELECTED_OPTION_PLACEHOLDER_CLASS} owc-select-dropdown .owc-input__input-container input {
        ${placeholderTextStyle}
    }

    owc-select-dropdown {
        width: 100%;

        /* OWC-OVERRIDE: the dropdown popover is an owc-card whose content wrapper adds
           padding around the option list; remove it so options sit edge-to-edge as in v6.
           owc-select-dropdown exposes no popover-padding prop in v7.6.0. */
        .owc-card .owc-card__content-wrapper {
            padding: unset;
        }

        /* OWC-OVERRIDE: tint the "extra action" option (e.g. "Add new…") in link blue.
           owc-list-item sets its own text colour on the internal container at a specificity
           this selector cannot beat without !important, and has no per-item colour prop in
           v7.6.0. */
        .extraAction {
            owc-icon {
                color: var(--one-color-blue-600);
            }

            .owc-list-item__list-item-container {
                > div {
                    color: var(--one-color-blue-600) !important;
                }
            }
        }
    }

    /* OWC-OVERRIDE: an inline select must fill the width its form row gives it. Both the
       trigger (owc-input) and owc's internal base-dropdown wrapper carry fixed widths in
       v7.6.0 with no width prop; !important is needed to beat owc's :host width on the
       trigger. */
    owc-select-dropdown.inline {
        .owc-input {
            width: 100% !important;
        }

        > .owc-base-dropdown {
            width: 100%;
        }
    }
`;

export const SelectErrorsLayout = styled.div`
    display: flex;
    flex-direction: column;

    &.space-for-error {
        height: 1rem;
    }

    owc-assistive-text {
        padding-left: 2rem;
    }

    &.floating-assistive-text {
        position: absolute;
    }
`;

export const OwcListStyled = styled(PocList)`
    max-height: 168px;
    overflow: auto;

    &[data-virtualization='true'] {
        height: 168px;
    }
`;

export const OwcListitemHiddenStyled = styled(PocListItem)`
    display: none;
`;
